import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconCategoryTextQuality({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} d="M13.329 11.645a1.5 1.5 0 0 1 1.342 0l.553.276a.5.5 0 0 1-.353.93l-.095-.036-.553-.276a.5.5 0 0 0-.447 0l-1.105.553c-.422.21-.92.21-1.342 0l-1.106-.553a.5.5 0 0 0-.447 0l-1.105.553c-.422.21-.92.21-1.342 0l-1.106-.553a.5.5 0 0 0-.447 0l-1.105.553c-.422.21-.92.21-1.342 0l-1.106-.553a.5.5 0 0 0-.447 0l-.553.276a.5.5 0 0 1-.447-.894l.553-.276a1.5 1.5 0 0 1 1.342 0l1.105.552c.14.07.307.07.447 0l1.106-.552a1.5 1.5 0 0 1 1.342 0l1.105.552c.14.07.307.07.447 0l1.106-.552a1.5 1.5 0 0 1 1.342 0l1.105.552c.14.07.307.07.447 0l1.106-.552z"/>
            <path fill={fill} fill-rule="evenodd" clip-rule="evenodd" d="M11.59 4.754c1.318 0 2.16.697 2.16 1.787v3.28c0 .351-.222.564-.537.564-.31 0-.522-.202-.532-.532v-.46h-.026c-.315.604-1.007.986-1.715.986-1.064 0-1.813-.66-1.813-1.637 0-.95.733-1.534 2.02-1.606l1.492-.088v-.42c0-.603-.408-.965-1.09-.965-.537 0-.893.192-1.202.688a.51.51 0 0 1-.456.237c-.278 0-.48-.186-.48-.465 0-.114.031-.237.099-.361.284-.615 1.104-1.008 2.08-1.008zm-.293 3.151c-.667.047-1.044.341-1.044.806 0 .475.398.785.992.785.78 0 1.395-.537 1.395-1.245v-.429l-1.343.083zM4.901 2.75c.403 0 .65.186.806.6L7.979 9.5a.985.985 0 0 1 .073.34c0 .306-.243.528-.579.528-.31 0-.48-.145-.584-.475l-.568-1.607h-2.85L2.907 9.89c-.108.335-.279.48-.578.48-.346 0-.58-.212-.58-.527 0-.088.021-.202.073-.341L4.09 3.354c.15-.413.403-.604.811-.604zM3.764 7.342h2.263l-1.12-3.27h-.032l-1.11 3.27z"/>
        </svg>

    );
}

export default IconCategoryTextQuality;

